import { render } from "./SkyDebug.vue?vue&type=template&id=24bf0820"
import script from "./SkyDebug.vue?vue&type=script&lang=js"
export * from "./SkyDebug.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__